import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MatTabsModule} from '@angular/material/tabs';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {EntitesComponent} from './components/parametrage-pages-components/entites/entites.component';
import {ListeProceduresComponent} from './components/pages-components/liste-procedures/liste-procedures.component';
import {CreateProcedureComponent} from './components/pages-components/create-procedure/create-procedure.component';
import {UtilisateursComponent} from './components/parametrage-pages-components/utilisateurs/utilisateurs.component';
import {
  CreerModifierUtilisateurComponent
} from './components/parametrage-pages-components/utilisateurs/creer-modifier-utilisateur/creer-modifier-utilisateur.component';
import {
  ModifierProcedureComponent
} from './components/pages-components/modifier-procedure/modifier-procedure.component';
import {AccountNotFoundComponent} from './components/pages-components/account-not-found/account-not-found.component';
import {
  ListeDocumentsComponent
} from './components/pages-components/document/liste-documents/liste-documents.component';
import {
  GroupeDiffusionComponent
} from './components/parametrage-pages-components/groupe-diffusion/groupe-diffusion.component';
import {JointjsPlusComponent} from "./components/jointjs-plus/jointjs-plus.component";
import {JointjsPageComponent} from "./components/pages-components/jointjs-page/jointjs-page.component";
import { ListeProceduresArchiveesComponent } from './components/pages-components/liste-procedures-archivees/liste-procedures-archivees.component';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'liste-procedures'},

  { path: 'administration/entites', component: EntitesComponent, data: { breadcrumb: 'Entités' } },
  { path: 'administration/utilisateurs', component: UtilisateursComponent, data: { breadcrumb: 'Liste des utilisateurs' }},
  { path: 'administration/utilisateurs/creer-utilisateur', component: CreerModifierUtilisateurComponent, data: { breadcrumb: 'Créer un utilisateur' }},
  { path: 'administration/utilisateurs/modifier-utilisateur/:id', component: CreerModifierUtilisateurComponent, data: { breadcrumb: 'Modifier un utilisateur' }},

  {path: 'groupe-diffusion', component: GroupeDiffusionComponent},


  { path: 'liste-procedures', component: ListeProceduresComponent, data: { breadcrumb: 'Liste des procédures' }},
  { path: 'liste-procedures-archivees', component: ListeProceduresArchiveesComponent, data: { breadcrumb: 'Liste des procédures archivées' }},
  { path: 'procedures/creer-procedure', component: CreateProcedureComponent, data: { breadcrumb: 'Créer une procédure' }},
  { path: 'procedures/modifier-procedure/:id', component: ModifierProcedureComponent, data: { breadcrumb: 'Modifier procédure' }},
  { path: 'procedures/logigramme-procedure/:idProcedure', component: JointjsPageComponent, data: { breadcrumb: 'Logigramme procédure' }},

  { path: 'liste-documents', component: ListeDocumentsComponent, data: { breadcrumb: 'Liste des documents' }},
  { path: 'jointjs', component: JointjsPlusComponent, data: { breadcrumb: 'JointJs' }},

  { path: 'account-not-found', component: AccountNotFoundComponent, data: { breadcrumb: 'Compte introuvable' }},
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    BrowserModule,
    BrowserAnimationsModule,
    MatTabsModule
  ],
  exports: [
    RouterModule
  ]
})

export class AppRoutingModule {
}
